// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --theme: #1A2C38;
    --primary: #14111F;
    --background: #241D3D;
    --secondary: #773DF3;
}

.plinko_plinko__BNMiY {
    display: flex;
    justify-content: center;
    min-height: 100vh;


}
.plinko_plinko__BNMiY * {
    font-size: 14px;
    font-weight: 600;
}
.plinko_plinko__BNMiY .plinko-container {
    
    padding-top: 24px;
    padding-bottom: 40px;
    width:90%;

}
.plinko_plinko__BNMiY .plinko-container{
    z-index:1000 !important;
    font-family: Poppins, sans-serif;
}
@media (max-width: 999px) {
    .plinko_plinko__BNMiY .plinko-container {
        padding-top: 24px;
        padding-bottom: 24px;
        width: 80%;
    }
    .plinko_plinko__BNMiY .plinko-container .game-box {
        border-width: 3px !important;
    }
}
@media (max-width: 1000px) {

    .plinko_plinko__BNMiY .plinko-container {
        margin-top:50px;
        margin-bottom: 60px;
        margin-left: 0;
        width: 90%;
    }
}
@media (max-width: 1000px){
    .plinko_plinko__BNMiY .plinko-container{

        width: 100% !important;
    }
}
.plinko_plinko__BNMiY .plinko-container .game-box {
    display: flex;
    overflow: hidden;
    outline: 1px solid #6d54c8;
    border: 3px solid var(--background);
    border-top-width: 5px;
    border-right-width: 4px;
    border-bottom-width: 8px;
    border-radius: 32px;
    background: var(--primary);
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 300px;
    padding: 40px 12px 12px;
    background-color: var(--background);
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .game-type {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 5px;
    border-radius: 10px;
    padding: 5px;
    background-color: var(--primary);
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .game-type button {
    display: flex;
    justify-content: center;
    border-radius: 8px;
    border: none;
    padding: 3px;
    background-color: transparent;
    font-size: 22px;
    line-height: 1.5;
    font-weight: 600;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .game-type button.active {
    background-color: var(--background);
    color: white;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .game-type button:not(.active) {
    color: #6f5cb2;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .game-type button:hover {
    background-color: var(--background);
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action span.title {
    margin-left: 4px;
    font-size: 18px;
    line-height: 1.5;
    font-weight: 600;
    color: #6d6198;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount .input-box {
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 5px;
    background-color: var(--primary);
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount .input-box span {
    margin-right: 4px;
    margin-left: 8px;
    font-size: 20px;
    line-height: 1.5;
    font-weight: 600;
    color:green;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount .input-box input {
    border: none;
    outline: none;
    margin-right: 8px;
    width: 80px;
    background-color: var(--primary);
    font-size: 20px;
    line-height: 1.5;
    font-weight: 600;
    color:green;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount .input-box div {
    display: flex;
    gap: 3px;
    margin-left: auto;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount .input-box div button {
    border: none;
    border-radius: 8px;
    padding: 8px;
    background-color: #1c182a;
    font-size: 16px;
    font-family: 'Poppins';
    color: #6f5cb2;

}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount .input-box div button:hover {
    background-color: var(--secondary);
    color: white;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount .input-box:hover {
    border-color: #557086;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .number-of-bets div {
    border-radius: 8px;
    background: var(--primary);
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .number-of-bets div input {
    margin: 8px;
    border: none;
    outline: none;
    padding-left: 4px;
    width: -webkit-fill-available;
    background-color: transparent;
    font-size: 18px;
    line-height: 1.5;
    color:#bfaef8;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .number-of-bets div input::-webkit-outer-spin-button, .plinko_plinko__BNMiY .plinko-container .game-box .bet-action .number-of-bets div input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .number-of-bets div:hover {
    border-color: #557086;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action .send-ball {
    margin-top: 12px;
    box-shadow: 0px 7px #5f2dca;
    height: 64px;
    border: none;
    background-color: var(--secondary);
    font-size: 22px;
    line-height: 1.5;
    font-weight: 700;
    color: #fff;
}
.plinko_plinko__BNMiY .plinko-container .game-box .bet-action.disabled input, .plinko_plinko__BNMiY .plinko-container .game-box .bet-action.disabled select {
    cursor: not-allowed;
}
@media (max-width: 999px) {
    .plinko_plinko__BNMiY .plinko-container .game-box {
        flex-direction: column-reverse;
        height: auto;
    }
    .plinko_plinko__BNMiY .plinko-container .game-box .bet-action {
        padding-top: 20px;
        width: auto;
    }
    .plinko_plinko__BNMiY .plinko-container .game-box .bet-action .bet-amount {
        order: -3;
    }
    .plinko_plinko__BNMiY .plinko-container .game-box .bet-action .send-ball {
        order: -2;
    }
    .plinko_plinko__BNMiY .plinko-container .game-box .bet-action .rows, .plinko_plinko__BNMiY .plinko-container .game-box .bet-action .risk, .plinko_plinko__BNMiY .plinko-container .game-box .bet-action .number-of-bets {
        order: -1;
    }
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100%;
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .left-ball-count {
    position: absolute;
    color:white;
    z-index: 2;
    top: 5%;
    left: 5%;
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board #plinko {
    position: relative;
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-box {
    display: flex;
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-box div {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    box-shadow: 0 4px;
    margin-bottom: 36px;
    border-radius: 5px;
    width: -webkit-fill-available;
    height: 28px;
    font-size: 12px;
    line-height: 0px;
    font-weight: bold;
    text-align: center;
    color: #000;
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-box div .gradient {
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    box-shadow: none;
    width: 144px;
    height: 144px;
    transform: translate3d(-50%, -50%, 0);
    background: radial-gradient(#ea3347,42, #ea3347 0, transparent);
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-box div.highlighted {
    animation-name: bounce;
    animation-duration: 300ms;
    animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
}
@media (max-width: 1079px) {
    .plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-box div {
        margin-bottom: 20px;
    }
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-history {
    position: absolute;
    top: 50%;
    right: 5%;
    display: flex;
    flex-direction: column;
    transform: translateY(-50%);
    width: 50px;
    height: 200px;
    overflow-y: hidden;
    border-radius: 12px;
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-history #multi-container {
    position: absolute;
    left: 0;
    width: 50px;
    height: auto;
}
.plinko_plinko__BNMiY .plinko-container .game-box .game-board .multiplier-history #multi-container button {
    border: none;
    border-radius: 0px;
    outline: none;
    width: 50px;
    height: 50px;
    font-weight: 700;
    color: #000 c;
    transition: all 1s ease-in-out;
}
.plinko_plinko__BNMiY .toggle-button {
    position: relative;
    margin-top: auto;
}
.plinko_plinko__BNMiY .toggle-button .react-toggle {
    position: absolute;
    bottom: -4px;
}
@media (max-width: 999px) {
    .plinko_plinko__BNMiY .toggle-button {
        margin-left: auto;
        margin-right: auto;
    }
    .plinko_plinko__BNMiY .toggle-button .react-toggle {
        position: relative;
        inset: 0px;
        margin-top: 4px;
    }
}
.plinko_plinko__BNMiY .mute-toggle.react-toggle--focus .react-toggle-thumb {
    box-shadow: none;
}
.plinko_plinko__BNMiY .mute-toggle.react-toggle:active .react-toggle-thumb {
    box-shadow: none;
}
.plinko_plinko__BNMiY .mute-toggle .react-toggle-track-x {
    right: 14px;
}
.plinko_plinko__BNMiY .mute-toggle .react-toggle-thumb {
    border: none;
}
.plinko_plinko__BNMiY .react-toggle--checked .react-toggle-track, .plinko_plinko__BNMiY .react-toggle--checked .react-toggle-track:hover {
    background-color: var(--secondary);
}
.plinko_plinko__BNMiY .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: var(--secondary);
}
.plinko_plinko__BNMiY .mute-icon {
    width: 16px;
    height: 12px;
    fill: white;
}
@media (max-width: 1536px) and (min-width: 1000px) {
    .plinko_plinko__BNMiY .plinko-container {
        height: 560px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/Pages/Plinko/plinko.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;;;AAGrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;;IAEI,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;;AAEb;AACA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB,UAAU;IACd;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;;IAEI;QACI,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,UAAU;IACd;AACJ;AACA;IACI;;QAEI,sBAAsB;IAC1B;AACJ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,0BAA0B;IAC1B,mCAAmC;IACnC,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,cAAc;;AAElB;AACA;IACI,kCAAkC;IAClC,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,6BAA6B;IAC7B,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,SAAS;AACb;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI;QACI,8BAA8B;QAC9B,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;AACJ;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,OAAO;IACP,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,+DAA+D;AACnE;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,+DAA+D;AACnE;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,eAAe;IACnB;AACJ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[":root {\n    --theme: #1A2C38;\n    --primary: #14111F;\n    --background: #241D3D;\n    --secondary: #773DF3;\n}\n\n.plinko :global {\n    display: flex;\n    justify-content: center;\n    min-height: 100vh;\n\n\n}\n.plinko :global * {\n    font-size: 14px;\n    font-weight: 600;\n}\n.plinko :global .plinko-container {\n    \n    padding-top: 24px;\n    padding-bottom: 40px;\n    width:90%;\n\n}\n.plinko :global .plinko-container{\n    z-index:1000 !important;\n    font-family: Poppins, sans-serif;\n}\n@media (max-width: 999px) {\n    .plinko :global .plinko-container {\n        padding-top: 24px;\n        padding-bottom: 24px;\n        width: 80%;\n    }\n    .plinko :global .plinko-container .game-box {\n        border-width: 3px !important;\n    }\n}\n@media (max-width: 1000px) {\n\n    .plinko :global .plinko-container {\n        margin-top:50px;\n        margin-bottom: 60px;\n        margin-left: 0;\n        width: 90%;\n    }\n}\n@media (max-width: 1000px){\n    .plinko :global .plinko-container{\n\n        width: 100% !important;\n    }\n}\n.plinko :global .plinko-container .game-box {\n    display: flex;\n    overflow: hidden;\n    outline: 1px solid #6d54c8;\n    border: 3px solid var(--background);\n    border-top-width: 5px;\n    border-right-width: 4px;\n    border-bottom-width: 8px;\n    border-radius: 32px;\n    background: var(--primary);\n}\n.plinko :global .plinko-container .game-box .bet-action {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    min-width: 300px;\n    padding: 40px 12px 12px;\n    background-color: var(--background);\n}\n.plinko :global .plinko-container .game-box .bet-action .game-type {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 5px;\n    border-radius: 10px;\n    padding: 5px;\n    background-color: var(--primary);\n}\n.plinko :global .plinko-container .game-box .bet-action .game-type button {\n    display: flex;\n    justify-content: center;\n    border-radius: 8px;\n    border: none;\n    padding: 3px;\n    background-color: transparent;\n    font-size: 22px;\n    line-height: 1.5;\n    font-weight: 600;\n}\n.plinko :global .plinko-container .game-box .bet-action .game-type button.active {\n    background-color: var(--background);\n    color: white;\n}\n.plinko :global .plinko-container .game-box .bet-action .game-type button:not(.active) {\n    color: #6f5cb2;\n}\n.plinko :global .plinko-container .game-box .bet-action .game-type button:hover {\n    background-color: var(--background);\n}\n.plinko :global .plinko-container .game-box .bet-action span.title {\n    margin-left: 4px;\n    font-size: 18px;\n    line-height: 1.5;\n    font-weight: 600;\n    color: #6d6198;\n}\n.plinko :global .plinko-container .game-box .bet-action .bet-amount .input-box {\n    display: flex;\n    align-items: center;\n    border-radius: 10px;\n    padding: 5px;\n    background-color: var(--primary);\n}\n.plinko :global .plinko-container .game-box .bet-action .bet-amount .input-box span {\n    margin-right: 4px;\n    margin-left: 8px;\n    font-size: 20px;\n    line-height: 1.5;\n    font-weight: 600;\n    color:green;\n}\n.plinko :global .plinko-container .game-box .bet-action .bet-amount .input-box input {\n    border: none;\n    outline: none;\n    margin-right: 8px;\n    width: 80px;\n    background-color: var(--primary);\n    font-size: 20px;\n    line-height: 1.5;\n    font-weight: 600;\n    color:green;\n}\n.plinko :global .plinko-container .game-box .bet-action .bet-amount .input-box div {\n    display: flex;\n    gap: 3px;\n    margin-left: auto;\n}\n.plinko :global .plinko-container .game-box .bet-action .bet-amount .input-box div button {\n    border: none;\n    border-radius: 8px;\n    padding: 8px;\n    background-color: #1c182a;\n    font-size: 16px;\n    font-family: 'Poppins';\n    color: #6f5cb2;\n\n}\n.plinko :global .plinko-container .game-box .bet-action .bet-amount .input-box div button:hover {\n    background-color: var(--secondary);\n    color: white;\n}\n.plinko :global .plinko-container .game-box .bet-action .bet-amount .input-box:hover {\n    border-color: #557086;\n}\n.plinko :global .plinko-container .game-box .bet-action .number-of-bets div {\n    border-radius: 8px;\n    background: var(--primary);\n}\n.plinko :global .plinko-container .game-box .bet-action .number-of-bets div input {\n    margin: 8px;\n    border: none;\n    outline: none;\n    padding-left: 4px;\n    width: -webkit-fill-available;\n    background-color: transparent;\n    font-size: 18px;\n    line-height: 1.5;\n    color:#bfaef8;\n}\n.plinko :global .plinko-container .game-box .bet-action .number-of-bets div input::-webkit-outer-spin-button, .plinko :global .plinko-container .game-box .bet-action .number-of-bets div input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n.plinko :global .plinko-container .game-box .bet-action .number-of-bets div:hover {\n    border-color: #557086;\n}\n.plinko :global .plinko-container .game-box .bet-action .send-ball {\n    margin-top: 12px;\n    box-shadow: 0px 7px #5f2dca;\n    height: 64px;\n    border: none;\n    background-color: var(--secondary);\n    font-size: 22px;\n    line-height: 1.5;\n    font-weight: 700;\n    color: #fff;\n}\n.plinko :global .plinko-container .game-box .bet-action.disabled input, .plinko :global .plinko-container .game-box .bet-action.disabled select {\n    cursor: not-allowed;\n}\n@media (max-width: 999px) {\n    .plinko :global .plinko-container .game-box {\n        flex-direction: column-reverse;\n        height: auto;\n    }\n    .plinko :global .plinko-container .game-box .bet-action {\n        padding-top: 20px;\n        width: auto;\n    }\n    .plinko :global .plinko-container .game-box .bet-action .bet-amount {\n        order: -3;\n    }\n    .plinko :global .plinko-container .game-box .bet-action .send-ball {\n        order: -2;\n    }\n    .plinko :global .plinko-container .game-box .bet-action .rows, .plinko :global .plinko-container .game-box .bet-action .risk, .plinko :global .plinko-container .game-box .bet-action .number-of-bets {\n        order: -1;\n    }\n}\n.plinko :global .plinko-container .game-box .game-board {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    width: 100%;\n}\n.plinko :global .plinko-container .game-box .game-board .left-ball-count {\n    position: absolute;\n    color:white;\n    z-index: 2;\n    top: 5%;\n    left: 5%;\n}\n.plinko :global .plinko-container .game-box .game-board #plinko {\n    position: relative;\n}\n.plinko :global .plinko-container .game-box .game-board .multiplier-box {\n    display: flex;\n}\n.plinko :global .plinko-container .game-box .game-board .multiplier-box div {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    box-shadow: 0 4px;\n    margin-bottom: 36px;\n    border-radius: 5px;\n    width: -webkit-fill-available;\n    height: 28px;\n    font-size: 12px;\n    line-height: 0px;\n    font-weight: bold;\n    text-align: center;\n    color: #000;\n}\n.plinko :global .plinko-container .game-box .game-board .multiplier-box div .gradient {\n    position: absolute;\n    z-index: -1;\n    top: 50%;\n    left: 50%;\n    box-shadow: none;\n    width: 144px;\n    height: 144px;\n    transform: translate3d(-50%, -50%, 0);\n    background: radial-gradient(#ea3347,42, #ea3347 0, transparent);\n}\n.plinko :global .plinko-container .game-box .game-board .multiplier-box div.highlighted {\n    animation-name: bounce;\n    animation-duration: 300ms;\n    animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\n}\n@media (max-width: 1079px) {\n    .plinko :global .plinko-container .game-box .game-board .multiplier-box div {\n        margin-bottom: 20px;\n    }\n}\n.plinko :global .plinko-container .game-box .game-board .multiplier-history {\n    position: absolute;\n    top: 50%;\n    right: 5%;\n    display: flex;\n    flex-direction: column;\n    transform: translateY(-50%);\n    width: 50px;\n    height: 200px;\n    overflow-y: hidden;\n    border-radius: 12px;\n}\n.plinko :global .plinko-container .game-box .game-board .multiplier-history #multi-container {\n    position: absolute;\n    left: 0;\n    width: 50px;\n    height: auto;\n}\n.plinko :global .plinko-container .game-box .game-board .multiplier-history #multi-container button {\n    border: none;\n    border-radius: 0px;\n    outline: none;\n    width: 50px;\n    height: 50px;\n    font-weight: 700;\n    color: #000 c;\n    transition: all 1s ease-in-out;\n}\n.plinko :global .toggle-button {\n    position: relative;\n    margin-top: auto;\n}\n.plinko :global .toggle-button .react-toggle {\n    position: absolute;\n    bottom: -4px;\n}\n@media (max-width: 999px) {\n    .plinko :global .toggle-button {\n        margin-left: auto;\n        margin-right: auto;\n    }\n    .plinko :global .toggle-button .react-toggle {\n        position: relative;\n        inset: 0px;\n        margin-top: 4px;\n    }\n}\n.plinko :global .mute-toggle.react-toggle--focus .react-toggle-thumb {\n    box-shadow: none;\n}\n.plinko :global .mute-toggle.react-toggle:active .react-toggle-thumb {\n    box-shadow: none;\n}\n.plinko :global .mute-toggle .react-toggle-track-x {\n    right: 14px;\n}\n.plinko :global .mute-toggle .react-toggle-thumb {\n    border: none;\n}\n.plinko :global .react-toggle--checked .react-toggle-track, .plinko :global .react-toggle--checked .react-toggle-track:hover {\n    background-color: var(--secondary);\n}\n.plinko :global .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: var(--secondary);\n}\n.plinko :global .mute-icon {\n    width: 16px;\n    height: 12px;\n    fill: white;\n}\n@media (max-width: 1536px) and (min-width: 1000px) {\n    .plinko :global .plinko-container {\n        height: 560px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"plinko": `plinko_plinko__BNMiY`
};
export default ___CSS_LOADER_EXPORT___;
